import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAdnocLogoIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "a",
	width: 122.73,
	height: 122.73,
	viewBox: "0 0 122.73 122.73",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("title", { children: "ADNOC Primary Brand Mark Artwork" }), /* @__PURE__ */ _jsxs("g", {
		transform: "matrix(2.9189 0 0 2.9189 -15.909 -15.909)",
		fill: "#1a4f92",
		fillRule: "evenodd",
		children: [
			/* @__PURE__ */ _jsx("path", { d: "m36.734 47.496h10.433c1.9784-10.493-5.1435-21.717-16.801-24.137 2.3804 0.63462 12.892 5.3492 10.253 17.324-0.58689 2.6635-1.9843 4.9545-3.885 6.8132" }),
			/* @__PURE__ */ _jsx("path", { d: "m5.4504 5.4504v42.041l4.4456 0.0017c2.6975-0.0065 3.3216 0.05534 4.796-0.17779 6.3596-0.93457 12.175-6.152 12.803-10.763 0.94078-5.4593-2.0063-10.243-7.6636-11.431-0.10068-0.02113-0.21044-0.05328-0.32781-0.09366-0.20136 0.0026-2.9592 0.0286-5.0843-0.54347-0.02633 0.02244-1.2206 0.97476-0.73034 2.8013 0 0-2.8335-2.9802-1.0327-6.9856 0 0 0.87236-1.8891 3.8341-3.8211 0.02281-0.02748 0.04561-0.0544 0.06823-0.08188 0.793-0.94784 2.6931-2.6196 5.4505-3.9394 1.4071-0.63806 3.8223-1.5524 6.5268-1.7861 12.336-1.1567 18.96 8.3576 18.96 8.3576v-13.58h-42.046" }),
			/* @__PURE__ */ _jsx("path", { d: "m35.842 15.777c5.3065 0.58008 9.9309 3.7606 11.654 5.4763l-0.0015 3.6631s-6.03-8.4899-17.332-8.1521c0.10786 0.40406 0.12528 0.83296 0.03466 1.2628-0.33414 1.5819-2.0063 2.5776-3.7339 2.2234-1.2913-0.26457-2.2476-1.2085-2.5091-2.3285-1.7782 0.62646-2.9311 1.2799-2.9311 1.2785 3.9246-2.693 8.9009-4.2008 14.819-3.4233" })
		]
	})]
});
export default SvgAdnocLogoIcon;
